import { render, staticRenderFns } from "./MenuPoem.vue?vue&type=template&id=535f56cd&scoped=true&"
import script from "./MenuPoem.vue?vue&type=script&lang=js&"
export * from "./MenuPoem.vue?vue&type=script&lang=js&"
import style0 from "./MenuPoem.vue?vue&type=style&index=0&id=535f56cd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "535f56cd",
  null
  
)

export default component.exports